export default {
  "content": "<path d=\"M10 1.929a1 1 0 10-2 0zM8 16.071a1 1 0 102 0zM16.071 10a1 1 0 100-2zM1.93 8a1 1 0 000 2zM8 1.929v14.142h2V1.93zM16.071 8H1.93v2H16.07z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 18 18",
    "fill": "none",
    "height": "18",
    "width": "18",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};